__turbopack_context__.v({
  "badge": "Ecosystem-module__lO09Ja__badge",
  "bounceAvatar": "Ecosystem-module__lO09Ja__bounceAvatar",
  "burst1": "Ecosystem-module__lO09Ja__burst1",
  "burst2": "Ecosystem-module__lO09Ja__burst2",
  "burst3": "Ecosystem-module__lO09Ja__burst3",
  "burstItem": "Ecosystem-module__lO09Ja__burstItem",
  "burstOut": "Ecosystem-module__lO09Ja__burstOut",
  "container": "Ecosystem-module__lO09Ja__container",
  "fillTrack": "Ecosystem-module__lO09Ja__fillTrack",
  "fillTrackVert": "Ecosystem-module__lO09Ja__fillTrackVert",
  "flowStage": "Ecosystem-module__lO09Ja__flowStage",
  "header": "Ecosystem-module__lO09Ja__header",
  "iconWrapper": "Ecosystem-module__lO09Ja__iconWrapper",
  "moneyBurst": "Ecosystem-module__lO09Ja__moneyBurst",
  "node1": "Ecosystem-module__lO09Ja__node1",
  "node2": "Ecosystem-module__lO09Ja__node2",
  "node3": "Ecosystem-module__lO09Ja__node3",
  "node4": "Ecosystem-module__lO09Ja__node4",
  "nodeCard": "Ecosystem-module__lO09Ja__nodeCard",
  "nodePulse": "Ecosystem-module__lO09Ja__nodePulse",
  "nodesContainer": "Ecosystem-module__lO09Ja__nodesContainer",
  "progressLine": "Ecosystem-module__lO09Ja__progressLine",
  "section": "Ecosystem-module__lO09Ja__section",
  "trackLine": "Ecosystem-module__lO09Ja__trackLine",
  "travelPath": "Ecosystem-module__lO09Ja__travelPath",
  "traveler": "Ecosystem-module__lO09Ja__traveler",
  "travelerIcon": "Ecosystem-module__lO09Ja__travelerIcon",
});
